import * as firebase from "firebase/app";
import "firebase/database";
import "firebase/storage";

import { SPARE_CREATE, SPARE_FETCH, SPARE_UPDATE } from "./types";

export const spareDeleteById = (data, files) => {
  return (dispatch) => {
    firebase
      .database()
      .ref("spares/" + data.id)
      .remove()
      .then(() => {
        const redirect = `/admin/sparedetail?id=${data.brand_id}&title=${data.brand_title}&type=${data.product_type}`;
        removeOldFile(files, redirect);
      });
  };
};

const removeOldFile = (src, redirect) => {
  const ref = firebase.storage().ref().child(src);
  // Delete the file
  ref
    .delete()
    .then(() => {
      window.location = redirect;
    })
    .catch((error) => {
      window.location = redirect;
    });
};

export const spareUpdate = (id, data, oldFiles) => {
  return (dispatch) => {
    dispatch({ type: SPARE_UPDATE, payload: true });
    const redirect = `/admin/sparedetail?id=${data.brand_id}&title=${data.brand_title}&type=${data.product_type}`;
    if (data.img) {
      // Change both catalog and img
      const storage = firebase.storage().ref();
      // Upload Img
      const filename = Date.now() + "." + data.img.name.split(".").pop();
      const fileRef = storage.child("spare/" + filename);
      fileRef.put(data.img).then(() => {
        fileRef.getDownloadURL().then((url) => {
          data.img = url;
          firebase
            .database()
            .ref("spares/" + id)
            .update(data)
            .then(async (res) => {
              removeOldFile(oldFiles, redirect);
            })
            .catch((err) => {
              dispatch({ type: SPARE_UPDATE, payload: false });
            });
        });
      });
    } else if (data.img === "") {
      // No file change
      delete data.img;
      // delete data.catalog
      firebase
        .database()
        .ref("spares/" + id)
        .update(data)
        .then(async (res) => {
          window.location = redirect;
        })
        .catch((err) => dispatch({ type: SPARE_UPDATE, payload: false }));
    }
  };
};

export const spareFetchBrand = () => {
  return (dispatch) => {
    let sparesRef = firebase.database().ref("spares");
    sparesRef.once("value", (snapshot) => {
      let data = [];
      snapshot.forEach((childSnapshot) => {
        let item = childSnapshot.val();
        if (typeof item === "object") {
          data.push(item);
        }
      });
      const uniqueBrand = [
        ...new Map(data.map((item) => [item.brand_id, item])).values(),
      ];
      dispatch({ type: SPARE_FETCH, payload: uniqueBrand });
    });
  };
};

export const spareFetchById = (id) => {
  return (dispatch) => {
    let sparesRef = firebase.database().ref("spares").child(id);
    sparesRef.once("value", (snapshot) => {
      const data = snapshot.val();
      dispatch({ type: SPARE_FETCH, payload: [data] });
    });
  };
};

export const spareFetchByBrand = (brand_id) => {
  return (dispatch) => {
    let sparesRef = firebase
      .database()
      .ref("spares")
      .orderByChild("brand_id")
      .equalTo(brand_id);
    sparesRef.once("value", (snapshot) => {
      let data = [];
      snapshot.forEach((childSnapshot) => {
        let item = childSnapshot.val();
        if (typeof item === "object") {
          data.push(item);
        }
      });
      dispatch({ type: SPARE_FETCH, payload: data.reverse() });
    });
  };
};

export const spareCreate = (data) => {
  return (dispatch) => {
    dispatch({ type: SPARE_CREATE, payload: true });
    const filename = Date.now() + "." + data.img.name.split(".").pop();
    const storage = firebase.storage().ref();
    const fileRef = storage.child("spare/" + filename);
    fileRef.put(data.img).then(() => {
      fileRef.getDownloadURL().then((url) => {
        data.img = url;
        const sparesRef = firebase.database().ref("spares").push();
        const id = sparesRef.key;
        data.id = id;
        sparesRef
          .set(data)
          .then((response) => {
            window.location = `/admin/sparedetail?id=${data.brand_id}&title=${data.brand_title}&type=${data.product_type}`;
          })
          .catch((err) => {
            console.log("spareCreate", err);
          });
      });
    });
  };
};
